import { AnimatePresence, motion } from "framer-motion";
import type { VoiceItemTypes } from "../../../../../utils/types";
import style from "./NewVoice.module.scss";
import VoiceItem from "./VoiceItem";

interface Props {
	selected: string;
	onClick: (value: string, ttsEngine: string) => void;
	items: {
		value: string;
		description?: string;
		preview_url?: string;
		useCase?: string;
		temper?: string;
		ttsEngine: string;
	}[];
}

const renderDropList: React.FC <Props>  = ({
	selected,
	onClick,
	items,
}) => {
	return (
		<AnimatePresence>
			{items.length > 0 && (
				<motion.div
					key="dropdown-list"
					layout
					className={`${style.dropdownList}`}
					initial={{ opacity: 0 }}
					exit={{ height: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.4 }}
					onClick={(e) => e.stopPropagation()}
				>
					<div className={style.scrollBar} />
					{items.map((el, index) =>
						<VoiceItem
							key={el.value}
							{...(el as VoiceItemTypes)}
							active={el.value === selected}
							onClick={onClick}
							index={index + 1}
							ttsEngine={el.ttsEngine}
						/>
					)}
				</motion.div>
			)}
		</AnimatePresence>
	);
};

export default renderDropList;
